<template>
	<div class="page">
		<div class="container2">
			<div class="header">
				<h1 class="title" v-text="title"/>
			</div>

			<div class="content">
				<slot/>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		title: {type: String, required: true}
	}
};
</script>

<style lang="scss" scoped>
.page {
	margin-top: em(70);
	@include res(tablet) {
		margin-top: em(35);
	}
	.header {
		.title {
			font-size: 20px;
			font-weight: 700;
			margin: 0;
			margin-bottom: 32px;
		}
	}
}
</style>
